function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}import "./avatar.scss";
import template from "./avatar.html";
import moment from "moment-timezone";

export var AvatarComponent = {
  template: template,
  bindings: {
    thumb: '<',
    badge: '<',
    dayProgressPercentage: '<?',
    onUserPicClick: '&',
    fullName: '<' },

  controller: /*#__PURE__*/function () {AvatarComponentController.$inject = ["LayoutService"];
    function AvatarComponentController(LayoutService) {
      "ngInject";_classCallCheck(this, AvatarComponentController);
      this.LayoutService = LayoutService;
      console.log(this);
      this.badge = '';
      this.tumb = '';
      this.showPhone = false;
    }_createClass(AvatarComponentController, [{ key: "$onInit", value: function $onInit()

      {
        // if (this.type == 3) {
        //   this.typeName = 'Dual Efficient';
        // }
        // else if (this.type == 2) {
        //   this.typeName = 'Fat Protein Efficient';
        // }
        // else if (this.type == 1) {
        //   this.typeName = 'Carbohydrate Efficient';
        // }
        // const nowPst = moment().tz("America/Los_Angeles");
        // if (nowPst.hour() >= 9 && nowPst.hour() < 17 && nowPst.day() >= 1 && nowPst.day() <= 5) this.showPhone = true;
      } }]);return AvatarComponentController;}() };